module.exports = __webpack_public_path__ + "static/media/delete-blue.7588e97e.svg";